import React from "react";
export var useTrackPublishStatusEdit = function (initial) {
    var _a = React.useState(initial), publishStatus = _a[0], setPublishStatus = _a[1];
    var validate = function () {
        return true;
    };
    return {
        value: publishStatus,
        set: setPublishStatus,
        validate: validate,
    };
};
